import { useMemo, useState, useEffect } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import PageTitle from '../../includes/PageTitle';
import Tables from "../../components/Tables/Tables";
import Modals from "../../components/Modals/Modals";
import SelectFild from '../../components/SelectFild/SelectFild';
import { FaCheckCircle } from "react-icons/fa";
import { useFormik } from 'formik';
import { ToastContainer, toast } from 'react-toastify';
import Loader from '../../components/Loader/Loader';
import { postCPOwnership, getCPOwnershipEmployee, postCPOwnershipTransfer, postCommunicationLogDropdown, postCommunicationLogHistory, postCommunicationLogSave } from '../../apiservices/ApiServices';
import TimeFild from '../../components/DateTimePicker/TimeFild';
import DateToDayFild from '../../components/DateTimePicker/DateToDayFild';

const ChannelPartners = () => {
    const [isLoading, setLoading] = useState(false);
    const [isLoadings, setLoadings] = useState(false);
    const [data, setData] = useState([]);
    const [showLogModal, setShowLogModal] = useState(false);
    const [assignedTo, setAssignedTo] = useState(false);
    const [viewHistory, setViewHistory] = useState(false);
    const [empData, setEmpData] = useState([]);
    const [empOptions, setEmpOptions] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [dropdownList, setDropdownList] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [logHistory, setLogHistory] = useState([]);

    const postCPOwnerships = async (postData) => {
        setLoading(true);
        try {
            const res = await postCPOwnership(postData);
            const formattedData = res?.data?.data?.records.map(item => ({
                id: item?.channel_partner_id,
                CpCode: item?.channel_partner_code,
                orgName: item?.org_organization.org_name,
                orgNameId: item?.org_organization.org_id,
                orgGroupName: item?.org_group?.org_group_name || 'N/A',
                orgGroupNameid: item?.org_group?.org_group_id || 'N/A',
                contactPersion: `${item?.org_contact_person?.first_name} ${item?.org_contact_person?.last_name}`,
                email: item?.org_contact_person?.email || 'N/A',
                mobile: item?.org_contact_person?.mobile_number || 'N/A',
                stageName: item?.stage?.stage_name || 'N/A',
                stageId: item?.stage?.stage_id || 'N/A',
                stageColor: item?.stage?.stage_color || 'N/A',

                userId: item?.current_owner?.user_id || '',
                ownershipMappingId: item?.current_owner?.ownership_mapping_id || '',
                ownershipName: `${item?.current_owner?.first_name} ${item?.current_owner?.last_name}`,
            }));
            setData(formattedData);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const postUpdateCPOwnerships = async () => {
        setLoading(true);
        let postData = {
            "search": "",
            "filters": {
                "org_group.org_group_name": "",
                "org_organization.org_name": "",
                "org_contact_person.first_name": "",
                "org_contact_person.last_name": ""
            },
            "page": 1,
            "length": 100
        }
        try {
            const res = await postCPOwnership(postData);
            const formattedData = res?.data?.data?.records.map(item => ({
                id: item?.channel_partner_id,
                CpCode: item?.channel_partner_code,
                orgName: item?.org_organization.org_name,
                orgNameId: item?.org_organization.org_id,
                orgGroupName: item?.org_group?.org_group_name || 'N/A',
                orgGroupNameid: item?.org_group?.org_group_id || 'N/A',
                contactPersion: `${item?.org_contact_person?.first_name} ${item?.org_contact_person?.last_name}`,
                email: item?.org_contact_person?.email || 'N/A',
                mobile: item?.org_contact_person?.mobile_number || 'N/A',
                stageName: item?.stage?.stage_name || 'N/A',
                stageId: item?.stage?.stage_id || 'N/A',
                stageColor: item?.stage?.stage_color || 'N/A',

                userId: item?.current_owner?.user_id || '',
                ownershipMappingId: item?.current_owner?.ownership_mapping_id || '',
                ownershipName: `${item?.current_owner?.first_name} ${item?.current_owner?.last_name}`,
            }));
            setData(formattedData);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    useEffect(() => {
        let postData = {
            "search": "",
            "filters": {
                "org_group.org_group_name": "",
                "org_organization.org_name": "",
                "org_contact_person.first_name": "",
                "org_contact_person.last_name": ""
            },
            "page": 1,
            "length": 100
        }
        postCPOwnerships(postData);
    }, []);

    const columns = useMemo(
        () => [
            {
                Header: "",
                accessor: "bAction",
                disableSortBy: true,
            },
            {
                Header: "CP Code",
                accessor: "CpCode",
            },
            {
                Header: "Org. Name",
                accessor: "orgName",
            },
            {
                Header: "Contact persion",
                accessor: "contactPersion",
            },
            {
                Header: "Email",
                accessor: "email",
            },
            {
                Header: "Mobile",
                accessor: "mobile",
            },
            {
                Header: "Stage",
                accessor: "stageName",
            },
            {
                Header: "Assigned To",
                accessor: "ownershipName",
            },
            {
                Header: "Action",
                accessor: "action",
                disableSortBy: true,
            },
        ],
        []
    );

    const actions = ['log', 'View History']

    const initialValues = {
        id: '',
        orgId: '',
        userid: '',
        remarks: '',

        typeId: '',
        interactionMode: '',
        interactionDate: '',
        interactionTime: '',
        contactPersonId: '',
        durationMinutes: '',
        statusId: '',
        nextFollowUpDate: '',
        notes: '',
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: '',
        onSubmit: async (values) => {
            setLoadings(true);
            if (showLogModal) {
                let postData = {
                    entity_id: values.id,
                    log_type: 'channel_partner',
                    interaction_mode: values.interactionMode,
                    interaction_date: values.interactionDate,
                    interaction_time: values.interactionTime,
                    contact_person_id: values.contactPersonId,
                    com_type_id: values.typeId,
                    notes: values.notes,
                    duration_minutes: values.durationMinutes,
                    status: values.statusId,
                    next_follow_up_date: values.nextFollowUpDate,
                }
                try {
                    const res = await postCommunicationLogSave(postData);
                    toast.success(res.data.message);
                    setLoadings(false);
                    setShowLogModal(false);
                    postUpdateCPOwnerships();

                } catch (error) {
                    setLoadings(false);
                    toast.error(error.response?.data?.message || "Error submitting data");
                }
            }
            else {
                let postData = {
                    channel_partner_ids: selectedIds,
                    user_id: values.userid,
                    remarks: values.remarks
                }
                try {
                    const res = await postCPOwnershipTransfer(postData);
                    toast.success(res.data.message);
                    setLoadings(false);
                    setAssignedTo(false);
                    postUpdateCPOwnerships();

                } catch (error) {
                    setLoadings(false);
                    toast.error(error.response?.data?.message || "Error submitting data");
                }
            }
        },
    });

    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;

    const handleLog = async (rowData) => {
        formik.resetForm();
        let postData = {
            entity_id: rowData?.id,
            log_type: "channel_partner"
        }

        try {
            const res = await postCommunicationLogDropdown(postData);
            setDropdownList(res.data.data);
            setFieldValue('id', rowData?.id);
            try {
                const res = await postCommunicationLogHistory(postData);
                setLogHistory(res.data.data);
                setLoadings(false);

            } catch (error) {
                setLoadings(false);
                toast.error(error.response?.data?.message || "Error submitting data");
            }

        } catch (error) {
            setAssignedTo(false);
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
        setShowLogModal(true);

    };

    const handlViewHistory = async (rowData) => {
        formik.resetForm();
        let postData = {
            entity_id: rowData?.id,
            log_type: "channel_partner"
        }

        try {
            const res = await postCommunicationLogHistory(postData);
            setLogHistory(res.data.data);
            setLoadings(false);
            setViewHistory(true);
        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const handleConfirm = () => {
        setAssignedTo(false);
        setShowLogModal(false);
        formik.resetForm();
    };

    const handleChk = (ids) => {
        setSelectedIds(ids);
    };

    const hendelAssignedTo = async () => {
        try {
            const res = await getCPOwnershipEmployee();
            setEmpData(res.data.data);
            formik.resetForm();
            setAssignedTo(true);
            setLoadings(false);
        } catch (error) {
            setAssignedTo(false);
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    useEffect(() => {
        if (values.orgId) {
            const selectedOption = empData.find(orgList => orgList.org_id == values.orgId);
            if (selectedOption && selectedOption.employees && selectedOption.employees.length > 0) {
                console.log('selectedOption.employees', selectedOption.employees)
                setEmpOptions(selectedOption.employees);
            } else {
                setEmpOptions([]);
            }
        } else {
            setEmpOptions([]);
        }
    }, [values.orgId, empData]);

    // const timelineItems = [
    //     {
    //         id: 1,
    //         date: "01/10/2025",
    //         time: '00:00',
    //         name: 'Abc',
    //         status: "Contact Later",
    //         FollowupDate: '10/10/2025'
    //     },
    //     {
    //         id: 2,
    //         date: "10/10/2025",
    //         time: '00:00',
    //         name: 'Abc',
    //         status: "Details Shared on Email",
    //         FollowupDate: '15/10/2025'
    //     },
    // ];

    return (
        <>
            <ToastContainer
                position="top-right"
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 9999999999, position: 'fixed' }}
            />

            {isLoading ? <Loader /> :
                <>
                    <PageTitle titles="Channel Partners" active="Channel Partners" items={['Home']} />
                    <Row>
                        <Col sm={12} className="col-12">
                            <Card>
                                <Card.Body className="example1-table notAddnew">
                                    <div className='custompageHed'>
                                        <Row>
                                            <Col md={6}>
                                                <div className='pagetitle_hed'>
                                                    <h1>Channel Partners</h1>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <Tables
                                        columns={columns}
                                        data={data}
                                        actions={actions}
                                        onLog={handleLog}
                                        onChk={handleChk}
                                        onToggleClick={hendelAssignedTo}
                                        onViewHistory={handlViewHistory}
                                    />
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            }

            <Modals
                show={assignedTo}
                handleClose={() => setAssignedTo(false)}
                title="Assigned To"
                textColor='#000'
                size='lg'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}

            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Row>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">Select Organization</label>
                                <SelectFild
                                    Firstop='Select Organization'
                                    selectName="orgId"
                                    options={empData}
                                    value={values.orgId}
                                    onChange={(selectedOption) => setFieldValue("orgId", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                                {errors.orgId && touched.orgId && (
                                    <p className="errormsg">{errors.orgId}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">Select Emp.</label>
                                <SelectFild
                                    Firstop='Select'
                                    selectName="userid"
                                    options={empOptions}
                                    value={values.userid}
                                    onChange={(selectedOption) => setFieldValue("userid", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                                {errors.userid && touched.userid && (
                                    <p className="errormsg">{errors.userid}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">Remarks</label>
                                <textarea
                                    id="remarks"
                                    name="remarks"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.remarks}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.remarks && touched.remarks && (
                                    <p className="errormsg">{errors.remarks}</p>
                                )}
                            </div>
                        </Col>
                    </Row>
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>Save</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>

            <Modals
                show={showLogModal}
                handleClose={() => setShowLogModal(false)}
                title="Communication Log"
                textColor='#000'
                size='xl'
                centered={true}
                backdrop={true}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Row>
                        <Col md={8}>
                            <Row>
                                <Col md={12}>
                                    <div className="form-group">
                                        <div className="table-responsive">
                                            <table className="table table-bordered text-nowrap mb-0">
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: 60 }}></th>
                                                        <th>First Name</th>
                                                        <th>Last Name</th>
                                                        <th>Email Id</th>
                                                        <th className="txt-left">Mobile Number</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {dropdownList?.contact_person?.map((item) => (
                                                        <tr key={`tab_content_person_${item?.contact_person_id}`}>
                                                            <td className='rdotd'>
                                                                <input
                                                                    type="radio"
                                                                    name="contactPersonId"
                                                                    value={item?.contact_person_id}
                                                                    checked={values.contactPersonId == item?.contact_person_id}
                                                                    onChange={(e) => { setFieldValue('contactPersonId', e.target.checked ? item?.contact_person_id : ''); }}
                                                                    onBlur={handleBlur}
                                                                />
                                                            </td>
                                                            <td>{item?.first_name}</td>
                                                            <td>{item?.last_name}</td>
                                                            <td>{item?.email}</td>
                                                            <td>{item?.mobile_number}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={12}>
                                    <div className="form-group">
                                        <div className='d-flex align-items-center'>
                                            <label className='mb-0'>Communication Types :</label>
                                            <div className='typeList'>
                                                {dropdownList?.communication_type?.map((item) => (
                                                    <div className='litBoxs' key={`typeIds_${item?.com_type_id}`}>
                                                        <input
                                                            type="radio"
                                                            name="typeId"
                                                            value={item?.com_type_id}
                                                            checked={values.typeId == item?.com_type_id}
                                                            onChange={(e) => {
                                                                if (e.target.checked) {
                                                                    setFieldValue('typeId', item?.com_type_id);
                                                                    setStatusList(item?.statuses)
                                                                }
                                                            }}
                                                            onBlur={handleBlur}
                                                        />
                                                        <div className='listContent'>
                                                            <img src={item?.com_type_icon} className="typeIo" alt={item?.com_type_name} title={item?.com_type_name} />
                                                            <p>{item?.com_type_name}</p>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label className="form-label">interaction Date</label>
                                        <DateToDayFild
                                            value={values.interactionDate}
                                            onChange={(date) => setFieldValue('interactionDate', date)}
                                            isMin={false}
                                            isMax={true}
                                        />
                                        {errors.interactionDate && touched.interactionDate && (
                                            <p className="errormsg">{errors.interactionDate}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label className="form-label">interaction Time</label>
                                        <TimeFild
                                            value={values.interactionTime}
                                            onChange={(time) => setFieldValue('interactionTime', time)}
                                            format="local"
                                        />
                                        {errors.interactionTime && touched.interactionTime && (
                                            <p className="errormsg">{errors.interactionTime}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label className="form-label">Select interaction Mode</label>
                                        <SelectFild
                                            Firstop='Select Interaction Mode'
                                            selectName="interactionMode"
                                            options={dropdownList?.interaction_mode}
                                            value={values.interactionMode}
                                            onChange={(selectedOption) => setFieldValue("interactionMode", selectedOption?.value || "")}
                                            onBlur={handleBlur}
                                        />
                                        {errors.interactionMode && touched.interactionMode && (
                                            <p className="errormsg">{errors.interactionMode}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label className="form-label">Select Status</label>
                                        <SelectFild
                                            Firstop='Select Status'
                                            selectName="statusId"
                                            options={statusList}
                                            value={values.statusId}
                                            onChange={(selectedOption) => setFieldValue("statusId", selectedOption?.value || "")}
                                            onBlur={handleBlur}
                                        />
                                        {errors.statusId && touched.statusId && (
                                            <p className="errormsg">{errors.statusId}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label className="form-label">duration Minutes</label>
                                        <input
                                            type='text'
                                            id="durationMinutes"
                                            name="durationMinutes"
                                            className="form-control"
                                            autoComplete='off'
                                            value={values.durationMinutes}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {errors.durationMinutes && touched.durationMinutes && (
                                            <p className="errormsg">{errors.durationMinutes}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label className="form-label">Next Scheduled Date</label>
                                        <DateToDayFild
                                            value={values.nextFollowUpDate}
                                            onChange={(date) => setFieldValue('nextFollowUpDate', date)}
                                            isMin={true}
                                            isMax={false}
                                        />
                                        {errors.nextFollowUpDate && touched.nextFollowUpDate && (
                                            <p className="errormsg">{errors.nextFollowUpDate}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={12}>
                                    <div className="form-group">
                                        <label className="form-label">Notes</label>
                                        <textarea
                                            id="notes"
                                            name="notes"
                                            className="form-control"
                                            autoComplete='off'
                                            value={values.notes}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {errors.notes && touched.notes && (
                                            <p className="errormsg">{errors.notes}</p>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={4}>
                            <div className="ScheduledBlock">
                                <h1>Communication History</h1>
                                <div className="Scheduledbox">
                                    <ul>
                                        {logHistory?.map((item) => (
                                            <li key={item?.interaction_id}>
                                                <div className='scheduled-date'>
                                                    <h6>{item?.interaction_datetime?.split(" ")?.[0]}</h6>
                                                    <p>{item?.interaction_datetime?.split(" ")?.[1]}</p>
                                                </div>
                                                <div className='scheduled-io'>
                                                    <FaCheckCircle />
                                                </div>
                                                <div className='scheduled-content'>
                                                    <h4>{item?.interaction_to?.name}</h4>
                                                    <p>{item?.status?.status_name}</p>
                                                    <p>Next Follow-up Date: {item?.next_follow_up_date}</p>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>

                        </Col>
                    </Row>
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>Save</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>

            <Modals
                show={viewHistory}
                handleClose={() => setViewHistory(false)}
                title="Communication History"
                textColor='#000'
                size='xl'
                centered={true}
                backdrop={true}
            >
                <div className='history-block'>
                    <div className="table-responsive">
                        <table className="table table-bordered text-nowrap mb-0">
                            <thead>
                                <tr>
                                    <th>com. Log Type</th>
                                    <th>com. Type</th>
                                    <th>interaction date time</th>
                                    <th>interaction mode</th>
                                    <th>duration minutes</th>
                                    <th>status</th>
                                    <th>From</th>
                                    <th>To</th>
                                    <th>Mobile Number</th>
                                    <th>Next Follow up Date</th>
                                    <th className="txt-left">Notes</th>
                                </tr>
                            </thead>
                            <tbody>
                                {logHistory?.map((item) => (
                                    <tr key={`tab_content_person_${item?.interaction_id}`}>
                                        <td>{item?.comm_log_type}</td>
                                        <td>{item?.communication_type?.com_type_name}</td>
                                        <td>{item?.interaction_datetime}</td>
                                        <td>{item?.interaction_mode}</td>
                                        <td>{item?.duration_minutes}</td>
                                        <td>{item?.status?.status_name}</td>
                                        <td>{item?.interaction_from?.name}</td>
                                        <td>{item?.interaction_to?.name}</td>
                                        <td>{item?.interaction_to?.mobile_number}</td>
                                        <td>{item?.next_follow_up_date}</td>
                                        <td>{item?.notes}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </Modals>

            {isLoadings && <Loader />}
        </>
    )
}

export default ChannelPartners